import {useEffect} from 'react'

import {Brand} from '@daedalus/core/src/brand/types'

import {
  FALLBACK_FONT_LANGUAGES,
  fallbackFontFaces,
  fontFaces
} from '../../experimental/FontsLoader/constants'

export type PropsType = {
  brand?: Brand
  languageCode: string
}

const fontVariables = `
  :root {
    --fontFamily: "Circular", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
    --letterSpacingAdjust-title4XL: -1px;
    --letterSpacingAdjust-title5XL: -1px;
  }
`

export const getFontFaces = (languageCode: string) =>
  FALLBACK_FONT_LANGUAGES.has(languageCode) ? fallbackFontFaces : fontFaces

export const FontsLoader = ({languageCode}: PropsType) => {
  useEffect(() => {
    const styles = `${getFontFaces(languageCode)}\n${fontVariables}`
    const style = document.createElement('style')
    style.innerHTML = styles
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [languageCode])

  return null
}
